<template>
  <div id="app">
    <div class="mrc-top">
      <div class="mrc-main">
        <div class="mrc-main-title">
          <span @click="jumpUrl()">
            {{ urlToolTitle ? `食用菌分子鉴别工作站 -- ${ urlToolTitle }` : '食用菌分子鉴别工作站' }}
          </span>
          <el-button
            type="primary"
            v-if="urlToolTitle"
            @click="get_help()"
          >
            帮助文档
          </el-button>
        </div>
        <div class="mrc-main-ribbon">
          <router-view/>
        </div>
      </div>
    </div>
    
    <div class="mrc-footer">
      <p>
        <img src="../public/mrc.png" style="height: 36px; vertical-align: middle;" />
        福建农林大学菌物研究中心
      </p>
      <div style="width:300px;margin:0 auto;">
		 		<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35010402351477" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img src="../src/assets/record.png" style="float:left;"/>
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">闽公网安备 35010402351477号</p>
        </a>
		 	</div>
		 
    </div>
    <el-drawer
      title="帮助文档"
      :visible.sync="getHelp"
      :direction="direction"
      close-on-press-escape
      :modal="false"
    >
      <component :is="iscomponent"></component>
    </el-drawer>
  </div>
</template>

<script>
import Mnp_help from './components/Mnp_help.vue'
import Hybrid_help from './components/Hybrid_help.vue'
export default {
  name: 'app',
  data() {
    return {
      urlToolTitle: this.$route.query.toolTitle,
      getHelp: false,
      direction: 'rtl',
      iscomponent: ''
    }
  },
  watch: {
    '$route.query.toolTitle'(val) {
      this.urlToolTitle = val
    }
  },
  components: { Mnp_help, Hybrid_help },
  methods: {
    jumpUrl() {
      this.$router.replace({name: 'home'})
    },
    putRecord() {
      window.open('http://beian.miit.gov.cn/')
    },
    get_help() {
      this.getHelp = true
      if (this.$route.query.toolsValue === 'Variety_identification_by_MNP_markers') {
        this.iscomponent = 'Mnp_help'
      } else if (this.$route.query.toolsValue === 'Paternity_testing') {
        this.iscomponent = 'Hybrid_help'
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
body {
  margin: 0 !important;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
.mrc-top {
  flex: 1;
  box-sizing: border-box;
  .mrc-main {
    padding: 0 100px;
    .mrc-main-title {
      cursor: pointer;
      font-family: 'STHupo';
      font-size: 30px;
      color: #3A6D3A;
      line-height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      border-bottom: 1px solid #ccc;
      .el-button--primary {
        height: 40px;
      }
    }
  }
}
.mrc-footer {
  height: 80px;
  line-height: 20px;
  // margin-top: auto;
  border-top: 1px solid #ccc;
  text-align: center;
  font-size: 16px;
  p {
    margin: 0;
    margin-top: 10px;
  }
  .record-contain {
    color: blue;
    cursor: pointer;
  }
}
#el-drawer__title {
  margin-bottom: 10px;
}
</style>
